import authUtils from '../../utils/authUtils';
import { dedupeByKey } from './sheetFormat';

// Chuỗi trong biểu thức AppSheet đặt trong nháy kép, nháy kép bên trong viết đôi.
export function quoteAppSheet(value) {
    return `"${String(value ?? '').replace(/"/g, '""')}"`;
}

export function equalsSelector(table, column, value) {
    return `Filter(${table}, [${column}] = ${quoteAppSheet(value)})`;
}

// Find có Selector để AppSheet lọc giúp, thay vì kéo cả bảng về rồi lọc ở trình duyệt.
// Truyền keyColumn để bỏ dòng API trả trùng.
export async function findRows(table, selector, keyColumn) {
    const data = selector ? { Properties: { Selector: selector } } : {};
    const rows = await authUtils.apiRequest(table, 'Find', data);
    const list = Array.isArray(rows) ? rows : [];
    return keyColumn ? dedupeByKey(list, keyColumn) : list;
}

// Khóa cho dòng mới do app tự sinh: tiền tố + thời điểm + phần ngẫu nhiên, không trùng khi ghi hàng loạt.
export function newId(prefix) {
    const random = Math.random().toString(36).slice(2, 8).toUpperCase();
    return `${prefix}-${Date.now().toString(36).toUpperCase()}${random}`;
}

const WRITE_BATCH_SIZE = 100;

// Ghi theo lô để một lần gọi không quá lớn. Edit chỉ cập nhật các cột có trong từng dòng.
export async function writeRows(table, action, rows, onProgress) {
    for (let start = 0; start < rows.length; start += WRITE_BATCH_SIZE) {
        const batch = rows.slice(start, start + WRITE_BATCH_SIZE);
        await authUtils.apiRequest(table, action, { Rows: batch });
        onProgress?.(Math.min(start + batch.length, rows.length), rows.length);
    }
}
